import React, { useEffect, useState } from "react";
import DHead from "../components/DHead";
import { axiosClient, getText } from "../Utlities/app-store";
import LoadingSpinner from "../components/LoadingSpinner";
import { Ask } from "fnon";

export default function Banners() {
  const [ads, setAds] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchAds();
  }, []);

  const fetchAds = async () => {
    try {
      const res = await axiosClient.get("/api/users/ads");
      setAds(res.data);
    } catch (err) {
      console.error("Error fetching ads", err);
    } finally {
      setLoading(false);
    }
  };

  const handleAdd = async (sortId) => {
    const fileInput = document.createElement("input");
    fileInput.type = "file";
    fileInput.accept = "image/*";
    fileInput.onchange = async (e) => {
      const file = e.target.files[0];
      if (!file) return;

      const formData = new FormData();
      formData.append("file", file);
      formData.append("sortId", sortId);

      try {
        const res = await axiosClient
          .post("/api/users/UploadAds", formData, {
            headers: { "Content-Type": "multipart/form-data" },
          })
          .then((d) => d.data)
          .then((nD) => {
            setAds(nD);
          });
      } catch (err) {
        console.error("Error uploading file", err);
      }
    };
    fileInput.click();
  };

  const handleDelete = (name) => {
    Ask.Danger({
      title: getText("confirmation"),
      message: `<div>
        <img src="/content/${name}" class="img-fluid mb-3" />
        <p>${getText("aresure")}</p>
        </div>`,
      btnOkText: getText("delete"),
      btnCancelText: getText("cancel"),
      callback: (y) => {
        if (y) {
          setLoading(true);
          axiosClient
            .post("/api/users/DelAd?name=" + name)
            .then((d) => {
              setAds(d.data);
            })
            .catch((err) => {
              console.error("Error deleting ad", err);
            })
            .finally(() => {
              setLoading(false);
            });
        }
      },
    });
  };

  return (
    <DHead title={getText("banners")} theme="info" bodyCss="card-body">
      {loading ? (
        <LoadingSpinner />
      ) : (
        <div>
          <div className="col-12 text-center my-3">
            <button
              className="btn btn-sm btn-primary"
              onClick={() => handleAdd(1)}
            >
              {getText("add")}
            </button>
          </div>
          {ads.map((item) => (
            <React.Fragment key={item.Url}>
              <div
                key={item.Url}
                href="#"
                target="_blank"
                className="card shadow"
              >
                <img
                  src={"/content/" + item.Url}
                  className="card-img-top img-fluid"
                  alt="Ad"
                />
              </div>
              <div className="col-12 text-center my-3">
                <div className="btn-group" role="group">
                  <button
                    className="btn btn-sm btn-danger"
                    onClick={() => handleDelete(item.Url)}
                  >
                    {getText("delete")}
                  </button>
                  <button
                    className="btn btn-sm btn-primary"
                    onClick={() => handleAdd(item.SortId + 1)}
                  >
                    {getText("add")}
                  </button>
                </div>
              </div>
            </React.Fragment>
          ))}
        </div>
      )}
    </DHead>
  );
}
